import { FILE_CONSTANTS } from "@/constants/documentUpload";
import { API_CONSTANTS, AUTH_CONSTANTS } from "../constants/";

// API Configuration for your existing upload service
export const API_CONFIG = {
  // Base URL of your upload service (using proxy in development)
  BASE_URL: import.meta.env.VITE_API_SERVER_URL || API_CONSTANTS.DEFAULT_BASE_URL,

  // Upload endpoints
  ENDPOINTS: {
    // Bulk file upload endpoint
    // UPLOAD_BULK: API_CONSTANTS.ENDPOINTS.UPLOAD_BULK,
    // New documents upload endpoint (streaming)
    DOCUMENTS_UPLOAD: API_CONSTANTS.ENDPOINTS.DOCUMENTS_UPLOAD,
    // Health check
    HEALTH: API_CONSTANTS.ENDPOINTS.HEALTH,
    // Authentication token endpoint
    AUTH_TOKEN: API_CONSTANTS.ENDPOINTS.AUTH_TOKEN,
  },

  // Authentication
  AUTH: {
    // Type of authentication your service uses
    TYPE: AUTH_CONSTANTS.TOKEN_TYPES.BEARER,
    // Header name for API key (if using api-key auth)
    API_KEY_HEADER: API_CONSTANTS.HEADERS.API_KEY,
  },

  // File upload settings
  UPLOAD: {
    // Maximum file size in bytes
    MAX_FILE_SIZE: FILE_CONSTANTS.MAX_FILE_SIZE_BYTES,
    // Accepted file types
    ACCEPTED_TYPES: FILE_CONSTANTS.ACCEPTED_MIME_TYPES,
    // Field name for documents in multipart/form-data
    DOCUMENTS_FIELD_NAME: FILE_CONSTANTS.DOCUMENTS_FIELD_NAME,
    // Default container name
    DEFAULT_CONTAINER: FILE_CONSTANTS.DEFAULT_CONTAINER_NAME,
  },
};

// Helper function to get full API URL
export const getApiUrl = (endpoint: string): string => {
  // If BASE_URL is empty, return the endpoint as a relative path
  // This allows the Vite proxy to intercept the request
  if (!API_CONFIG.BASE_URL) {
    return endpoint;
  }

  // If BASE_URL is provided, concatenate it with the endpoint
  return `${API_CONFIG.BASE_URL}${endpoint}`;
};
